import { render, staticRenderFns } from "./subordianteheader.vue?vue&type=template&id=632ff583&scoped=true"
import script from "./subordianteheader.vue?vue&type=script&lang=js"
export * from "./subordianteheader.vue?vue&type=script&lang=js"
import style0 from "./subordianteheader.vue?vue&type=style&index=0&id=632ff583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ff583",
  null
  
)

export default component.exports